/** This file contains constants used across the project */
export const MODULE_NAME = 'kfone-payequity';
export const TRANSLATION_ID = 'frontend';
export const TABLE_ACTION_MENU_NAME = 'action_menu_items';
